import { render, staticRenderFns } from "./FanTagInput.vue?vue&type=template&id=227c79b8&"
import script from "./FanTagInput.vue?vue&type=script&lang=js&"
export * from "./FanTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports